import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    contactUsCta: 'Contact us',
    description:
      'Unfortunately only a corporate officer can open an account for the moment.',
    title: 'Hey there',
  },
  fr: {
    contactUsCta: 'Nous contacter',
    description:
      'Pour le moment, le compte peut être créé uniquement par un·e dirigeant·e de l’entreprise.',
    title: 'Nous sommes désolés',
  },
} as const);
